define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.splice;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/splice.js
// module id = 1053
// module chunks = 0